import React from "react";
import {LoadWebsiteDetailsEpic} from '../../actions/website.actions';
import {connect} from 'react-redux'
import { withRouter } from 'react-router-dom'
import CircularProgress from 'material-ui/CircularProgress';

import WebsiteContentHome from './WebsiteContentHome';
import WebsiteContentAbout from './WebsiteContentAbout';
import WebsiteContentContact from './WebsiteContentContact';
import WebsiteContentPhotoGallery from './WebsiteContentPhotoGallery';
import WebsiteContentMenu from './WebsiteContentMenu';
import WebsiteContentLanding from './WebsiteContentLanding';
import WebsiteContentEvents from './WebsiteContentEvents';
import WebsiteContentReservations from './WebsiteContentReservations';
import WebsiteContentSettings from './WebsiteContentSettings';
import WebsiteStyles from './WebsiteStyles';

import {
  Route,
  Switch,
} from 'react-router-dom';
export class WebsiteHome extends React.Component {



  componentDidMount() {
    this.props.loadWebsiteDetails(this.props.companyId);
  }

  render() {
    if (this.props.loading) {
      return  (
        <div style={{textAlign: 'center'}}>
          <CircularProgress/>
        </div>
      );
    }


    return (
      <div>
        <Switch>
          <Route path="/website/home" component={WebsiteContentHome}/>
          <Route path="/website/about" component={WebsiteContentAbout}/>
          <Route path="/website/photogallery" component={WebsiteContentPhotoGallery}/>
          <Route path="/website/menu" component={WebsiteContentMenu}/>
          <Route path="/website/contact" component={WebsiteContentContact}/>
          <Route path="/website/landing" component={WebsiteContentLanding}/>
          <Route path="/website/events" component={WebsiteContentEvents}/>
          <Route path="/website/reservations" component={WebsiteContentReservations}/>
          <Route path="/website/websitesettings" component={WebsiteContentSettings}/>
          <Route path="/website/styles" component={WebsiteStyles}/>

          <Route path="/company/:companyId/website/home" component={WebsiteContentHome}/>
          <Route path="/company/:companyId/website/about" component={WebsiteContentAbout}/>
          <Route path="/company/:companyId/website/photogallery" component={WebsiteContentPhotoGallery}/>
          <Route path="/company/:companyId/website/menu" component={WebsiteContentMenu}/>
          <Route path="/company/:companyId/website/contact" component={WebsiteContentContact}/>
          <Route path="/company/:companyId/website/landing" component={WebsiteContentLanding}/>
          <Route path="/company/:companyId/website/events" component={WebsiteContentEvents}/>
          <Route path="/company/:companyId/website/reservations" component={WebsiteContentReservations}/>
          <Route path="/company/:companyId/website/websitesettings" component={WebsiteContentSettings}/>
          <Route path="/company/:companyId/website/styles" component={WebsiteStyles}/>
        </Switch>
      </div>
    );
  }
}

let mapStateToProps = ({websiteEndpoint, nav, authEndpoint},{match}) => ({
  loading: websiteEndpoint.fetchInProgress,
  error: websiteEndpoint.fetchError? true:false,
  website: websiteEndpoint.website,
  companyId: nav.selectedCompany? nav.selectedCompany : authEndpoint.companyId 
})

let mapDispatchToProps = (dispatch) => ({
  loadWebsiteDetails : (companyId) => dispatch(LoadWebsiteDetailsEpic(companyId)),
});

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(WebsiteHome));





// WEBPACK FOOTER //
// ./src/containers/Website/WebsiteHome.js